<template>
  <div class="flex items-start mb-4 pb-4 border-b-2">
    <div class="md:w-4/5 flex flex-col">
      <span class="text-left pb-2 uppercase text-sm tracking-wider">Pregunta</span>
      <input
        :class="{'border-red-500': question.error}"
        class="bg-gray-200 appearance-none border-2 border-pink-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-pink-300"
        type="text"
        v-model="question.value"
      />
      <p v-if="question.error" class="text-red-500 text-xs italic text-left">Ingrese la pregunta.</p>
    </div>
    <div class="md:w-1/5 flex justify-center">
      <button
        type="button"
        class="flex items-center px-2 py-1 rounded bg-red-500 text-gray-100 hover:bg-red-700"
        @click="remove"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "geolocation-question",
  methods: {
    remove() {
      this.$emit("click");
    }
  },
  props: {
    question: {
      required: true
    }
  }
};
</script>

<style scoped>
</style>
